export const parseDate = (dateString) => {
  const date = new Date(dateString);

  return {
    iso8601: date.toISOString(),
    pretty: dateString.split('-')[0],
  };
};
